"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLinkButton = exports.ctx = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.ctx = React.createContext(null);
const useLinkButton = () => {
    const state = React.useContext(exports.ctx);
    if (!state)
        throw new Error('NO_CTX');
    return state;
};
exports.useLinkButton = useLinkButton;
